"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var check_1 = require("./methods/check");
var dateAdd_1 = require("./methods/dateAdd");
var dateSet_1 = require("./methods/dateSet");
var dateDiff_1 = require("./methods/dateDiff");
var datePart_1 = require("./methods/datePart");
var dateParse_1 = require("./methods/dateParse");
var generateGuid_1 = require("./methods/generateGuid");
var trim_1 = require("./methods/trim");
var fnumber_1 = require("./methods/fnumber");
var fmoney_1 = require("./methods/fmoney");
var fdatetime_1 = require("./methods/fdatetime");
var fdate_1 = require("./methods/fdate");
var ftime_1 = require("./methods/ftime");
var listMonths_1 = require("./methods/listMonths");
var listYears_1 = require("./methods/listYears");
var min_1 = require("./methods/min");
var max_1 = require("./methods/max");
var mround_1 = require("./methods/mround");
var now_1 = require("./methods/now");
var nullDefault_1 = require("./methods/nullDefault");
var padNumber_1 = require("./methods/padNumber");
var today_1 = require("./methods/today");
exports.default = {
    check: check_1.default,
    dateAdd: dateAdd_1.default,
    dateSet: dateSet_1.default,
    dateDiff: dateDiff_1.default,
    datePart: datePart_1.default,
    dateParse: dateParse_1.default,
    generateGuid: generateGuid_1.default,
    fdate: fdate_1.default,
    fdatetime: fdatetime_1.default,
    fnumber: fnumber_1.default,
    fmoney: fmoney_1.default,
    ftime: ftime_1.default,
    listMonths: listMonths_1.default,
    listYears: listYears_1.default,
    min: min_1.default,
    max: max_1.default,
    mround: mround_1.default,
    now: now_1.default,
    nullDefault: nullDefault_1.default,
    padNumber: padNumber_1.default,
    today: today_1.default,
    trim: trim_1.default
};
/*
export default {
    mround,
    min,
    max,
    nullDefault,
    fmoney,
    fdate,
    ftime,
    fdatetime,
    padNumber,
    datePart,

    dateAdd,
    dateDiff: TimeSpan.diff,
    today: () => fdate(new Date()),
    now: () => fdatetime(new Date()),
    guid: generateGuid,
    check: (format: string, value: string): boolean => checkFormat(format, value),
    checkFormat,
};
*/
//# sourceMappingURL=schemaMethods.js.map